<template>
  <v-container class="main-container">
    <div class="pageTitle">{{ ownerName }} タイムシート</div>
    <v-layout grid-list-md align-center row>
      <v-flex md3>
        <v-icon @click="prvMonth">keyboard_arrow_left</v-icon>
        <div class="yearMonth">{{ year }}年{{ month }}月</div>
        <v-icon @click="nextMonth">keyboard_arrow_right</v-icon>
      </v-flex>
      <v-flex md2 offset-md2>
        <v-text-field
          :value="timesheetStatus ? timesheetStatus : '読み込み中'"
          label="ステータス"
          :disabled="!timesheetStatus"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex md2>
        <v-btn
          color="deep-orange"
          class="white--text"
          :disabled="cannotEdit"
          @click.stop="submitTimesheet"
          >提出</v-btn
        >
      </v-flex>
      <v-flex md1>
        <v-btn flat icon color="grey darken-2" @click.stop="dialog = true">
          <v-icon>history</v-icon>
        </v-btn>
      </v-flex>
      <v-flex md2>
        <v-overflow-btn
          :items="timesheetControlers"
          label="承認操作"
          segmented
          v-if="CanI('ApproveTimesheet')"
        ></v-overflow-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="500" v-if="dialog">
      <v-card>
        <v-card-text>
          <div class="tableTitle">承認履歴</div>
          <table v-show="timesheetHistory.length > 0">
            <tr>
              <th>日時</th>
              <th>名前</th>
              <th>内容</th>
            </tr>
            <tr v-for="(item, i) in timesheetHistory" :key="i">
              <td>{{ toFormattedDatetime(item.unixtime) }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.msg }}</td>
            </tr>
          </table>
          <p id="no-history-msg" v-show="timesheetHistory.length == 0">
            履歴はありません。
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-tabs
      color="deep-orange"
      dark
      slider-color="red lighten-4"
      v-if="hasLoaded"
    >
      <v-tab ripple>タイムシート</v-tab>
      <v-tab ripple>集計</v-tab>
      <v-tab ripple>原価</v-tab>
      <v-tab ripple v-if="isMyHome || CanI('ReadOtherMoneyTable')"
        >月設定</v-tab
      >
      <v-tab-item>
        <time-table v-if="timesheetItems" :read-only="cannotEdit" />
      </v-tab-item>
      <v-tab-item>
        <v-layout align-start justify-start fill-height row>
          <v-flex md4>
            <date-counts-table v-if="owner.work_type == '一般'" />
            <hourly-date-counts-table v-else />
          </v-flex>
          <v-flex md4>
            <time-counts-table v-if="owner.work_type == '一般'" />
            <hourly-time-counts-table v-else />
          </v-flex>
          <v-flex md4 v-if="isMyHome || CanI('ReadOtherMoneyTable')">
            <money-counts-table v-if="owner.work_type == '一般'" />
            <hourly-money-counts-table v-else />
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <cost-counts-table />
      </v-tab-item>
      <v-tab-item v-if="isMyHome || CanI('ReadOtherMoneyTable')">
        <timesheet-setting :read-only="cannotEdit" />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import TimeTable from "@/components/Home/timeTable";
import DateCountsTable from "@/components/Home/dateCountsTable";
import HourlyDateCountsTable from "@/components/Home/dateCountsTableForHourlyStaff";
import TimeCountsTable from "@/components/Home/timeCountsTable";
import HourlyTimeCountsTable from "@/components/Home/timeCountsTableForHourlyStaff";
import MoneyCountsTable from "@/components/Home/moneyCountsTable";
import HourlyMoneyCountsTable from "@/components/Home/moneyCountsTableForHourlyStaff";
import CostCountsTable from "@/components/Home/costCountsTable";
import TimesheetSetting from "@/components/Home/timesheetSetting";

import { mapGetters, mapState, mapActions } from "vuex";
import {
  getMoment,
  getUnixtime,
  unixtimeToFormattedDatetime,
} from "@/utils/datetime.js";

export default {
  components: {
    TimeTable,
    DateCountsTable,
    HourlyDateCountsTable,
    TimeCountsTable,
    HourlyTimeCountsTable,
    MoneyCountsTable,
    HourlyMoneyCountsTable,
    CostCountsTable,
    TimesheetSetting,
  },
  data() {
    return {
      dbRef: db.collection("calendar"),
      dialog: false,
      year: 2019,
      month: 1,
      date: 1,
      dates: [],
      timesheet: {},
      costCounts: {},
      timesheetControlers: [
        { text: "確認", callback: () => this.leaderConfirmTimesheet() },
        { text: "最終確認", callback: () => this.adminConfirmTimesheet() },
        { text: "差戻し", callback: () => this.returnTimesheet() },
      ],
    };
  },
  created() {},
  mounted() {
    const today = getMoment()();
    this.month = this.$route.query.month
      ? Number(this.$route.query.month)
      : today.month() + 1;
    this.year = this.$route.query.year
      ? Number(this.$route.query.year)
      : today.year();
    this.date = today.date();
  },
  computed: {
    month_id() {
      return String(this.year) + "-" + ("0" + this.month).slice(-2);
    },
    isMyHome() {
      return this.user.uid == this.$route.params.user_id;
    },
    ownerName() {
      return this.owner && this.owner.name ? this.owner.name : "";
    },
    cannotEdit() {
      return (
        this.CanI("CannotEdit") ||
        !this.timesheetStatus ||
        this.timesheetStatus != "入力中"
      );
    },
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user", "profile"]),
    ...mapGetters("timesheet", [
      "timesheetItems",
      "owner",
      "timesheetStatus",
      "timesheetHistory",
      "hasLoaded",
    ]),
    ...mapState("auth", ["user_type", "work_type", "team_name", "authorities"]),
  },
  watch: {
    month_id() {
      this.reloadItems();
    },
    $route() {
      this.reloadItems();
    },
  },
  methods: {
    async submitTimesheet() {
      if (confirm("タイムシートを提出しますか？\n")) {
        try {
          this.changeLoadingState(true);
          await this.changeTimesheetStaus({
            status: "提出済",
            history: {
              name: this.profile.name,
              msg: "提出しました。",
              unixtime: getUnixtime(),
            },
          });
        } catch (e) {
          console.error(e);
        } finally {
          this.changeLoadingState(false);
        }
      }
    },
    async returnTimesheet() {
      if (confirm("タイムシートを差戻しますか？\n")) {
        try {
          this.changeLoadingState(true);
          await this.changeTimesheetStaus({
            status: "入力中",
            history: {
              name: this.profile.name,
              msg: "差戻しました。",
              unixtime: getUnixtime(),
            },
          });
        } catch (e) {
          console.error(e);
        } finally {
          this.reloadItems();
          this.changeLoadingState(false);
        }
      }
    },
    async leaderConfirmTimesheet() {
      if (confirm("タイムシートを確認済みにしますか？\n")) {
        try {
          this.changeLoadingState(true);
          await this.changeTimesheetStaus({
            status: "リーダー確認済",
            history: {
              name: this.profile.name,
              msg: "リーダー確認済にしました。",
              unixtime: getUnixtime(),
            },
          });
        } catch (e) {
          console.error(e);
        } finally {
          this.changeLoadingState(false);
        }
      }
    },
    async adminConfirmTimesheet() {
      if (confirm("タイムシートを最終確認済みにしますか？\n")) {
        try {
          this.changeLoadingState(true);
          await this.changeTimesheetStaus({
            status: "最終確認済",
            history: {
              name: this.profile.name,
              msg: "最終確認済にしました。",
              unixtime: getUnixtime(),
            },
          });
        } catch (e) {
          console.error(e);
        } finally {
          this.reloadItems();
          this.changeLoadingState(false);
        }
      }
    },

    async reloadItems() {
      this.changeLoadingState(true);
      try {
        await this.getTimesheet({
          monthId: this.month_id,
          ownerId: this.$route.params.user_id,
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.changeLoadingState(false);
      }
    },
    countDate(date) {
      if (date.is_holiday || date.day_number == 0 || date.day_number == 6) {
        this.datesCounts.dayOff++;
      }
    },
    prvMonth() {
      const m = getMoment();
      const thisMonth = m(this.month_id + "-01").subtract(1, "M");
      this.year = thisMonth.year();
      this.month = thisMonth.month() + 1;
    },
    nextMonth() {
      const m = getMoment();
      const thisMonth = m(this.month_id + "-01").add(1, "M");
      this.year = thisMonth.year();
      this.month = thisMonth.month() + 1;
    },
    clearCount() {
      this.datesCounts.dayOff = 0;
    },
    toFormattedDatetime(unixtime) {
      return unixtimeToFormattedDatetime(unixtime);
    },
    ...mapActions("app", ["changeLoadingState"]),
    ...mapActions("timesheet", ["getTimesheet", "changeTimesheetStaus"]),
  },
};
</script>

<style lang="css" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
#no-history-msg {
  margin: 10px;
}
div.yearMonth {
  display: inline-block;
  font-size: 20px;
  /* color: #ddd; */
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle {
  font-size: 16px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle:before {
  content: "";
  background-color: #ff5722;
  display: inline-block;
  height: 15px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  width: 15px;
}
table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
}
th {
  text-align: left;
}
th,
td {
  border: solid 1px;
  padding: 5px 10px;
}
td {
  text-align: right;
}

</style>